import { Text, Box } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const Title = styled(Text)`
  p {
    font-size: 28px;
  }
`

export const LeftColumn = styled(Box)`
  flex: 1;
  @media (max-width: 1000px) {
    width: 100%;
  }
`

export const RightColumn = styled(Box)`
  width: 45%;
  @media (max-width: 1000px) {
    width: 100%;
  }
`
